import { Instagram, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#050505] border-t border-white/5 py-12 px-6 md:px-12 lg:px-24"
    >
      <div className="mx-auto max-w-[1600px] flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div className="flex items-center gap-3">
          <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]" />
          <span className="font-serif-display text-xl text-white">CinematicLee</span>
        </div>

        <p className="font-accent text-[9px] text-zinc-600 max-w-md">
          © {new Date().getFullYear()} CinematicLee · Cinematographer ·
          Made with patient light and too much coffee.
        </p>

        <div className="flex items-center gap-5">
          <a
            href="mailto:elfordleeman@gmail.com"
            data-testid="footer-email"
            className="text-zinc-500 hover:text-[#D4AF37] transition-colors"
            aria-label="Email"
          >
            <Mail size={16} strokeWidth={1.25} />
          </a>
          <a
            href="https://www.instagram.com/leeman09/"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-instagram"
            className="text-zinc-500 hover:text-[#D4AF37] transition-colors"
            aria-label="Instagram"
          >
            <Instagram size={16} strokeWidth={1.25} />
          </a>
        </div>
      </div>
    </footer>
  );
}
